<!-- <input type="text" class="form-control input-lg" [(ngModel)]="searchTerm" (ngModelChange)="searchOnRows()" placeholder="Search" /> -->

<!-- <input type="text" class="form-control input-lg" [(ngModel)]="searchTerm" (ngModelChange)="searchOnRows()" placeholder="Search" /> -->

<div id="fn-search-input" class="input-group table-search right">
    <input type="text" class="form-control" id="fn-grid-serch-i" (input)="debounce($event.target.value)" placeholder="Type to search" fnAutoFocus />
    <div class="input-group-append">
        <button class="btn btn-outline-secondary btn-sm" type="button">
			<i class="fn-global-times red" (click)="handleClose()"></i>
		</button>
    </div>
</div>